import '@fancyapps/fancybox';
import {animateInViewport} from "../transition";

$( '.timeline-carousel' ).each( function() {
	var $this = $( this );

	var slidesPerView = $this.attr( 'data-slides-per-view' );

	var swiper = new Swiper( this, {
		pagination: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1.2,
		breakpoints: {
			1024: {
				slidesPerView: slidesPerView,
			},
		},
		spaceBetween: 0,
		grabCursor: true,
		autoplay: true,

	} );
} );


$( '.card-carousel' ).each( function() {
	var $this = $( this );

	var slidesPerView = $this.attr( 'data-slides-per-view' );

	var swiper = new Swiper( this, {
		pagination: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1.2,
		breakpoints: {
			1024: {
				slidesPerView: slidesPerView,
			},
		},
		spaceBetween: 0,
		grabCursor: true,
	} );

	var $indicator = $this.parents( '.carousel-container' ).find( '.carousel-indicator' );

	updateIndicator( swiper, $indicator );

	swiper.on( 'slideChange', function() {
		updateIndicator( swiper, $indicator );
		animateInViewport();
	} );
} );

function updateIndicator( swiper, $indicator ) {
	let slices = swiper.slides.length;

	if ( $( window ).width() >= 1024 ) {
		slices = swiper.slides.length - 4;
	}

	if ( slices <= 1 ) {
		slices = 2;
	}
	$indicator.css( {
		'width': (100 / slices * (swiper.activeIndex + 1)) + '%',
	} );
}
